import { Link } from "react-router-dom";


const games = [
  {
    name: "Canasta",
    path: "/Games/Canasta",
    image: "/thumbnails/Canasta_thumb.png",
    description: "Traditional rummy-style card game with two decks and wild cards."
  },
  {
    name: "Bingo",
    path: "/Games/Bingo",
    image: "/thumbnails/Bingo_thumb.png",
    description: "Eyes down for a full house! Mark off numbers on your card as they are called out."
  },
  {
    name: "Go",
    path: "/Games/Go",
    image: "/thumbnails/Go_thumb.png",
    description: "Ancient board game of strategy and territory control."
  },
  {
    name: "Hangman",
    path: "/Games/Hangman",
    image: "/thumbnails/Hangman_thumb.png",
    description: "Classic word guessing game where players try to guess a hidden word or phrase by suggesting letters."
  },
  {
    name: "Face Finder",
    path: "/Games/FaceFinder",
    image: "/thumbnails/FaceFinder_thumb.png",
    description: "Shared-target portrait deduction game where players narrow down the hidden face and race to guess it first."
  },
  {
    name: "Canvas Craze",
    path: "/Games/CanvasCraze",
    image: "/thumbnails/CanvasCraze_thumb.png",
    description: "Collaborative real-time drawing game with creative tools and multiplayer guessing."
  },
  {
    name: "Texas Hold'em Poker",
    path: "/Games/Poker",
    image: "/thumbnails/Poker_thumb.png",
    description: "The classic poker game of skill, strategy, and bluffing. Compete to win the pot!"
  },
  {
    name: "Snakes and Ladders",
    path: "/Games/SnakesAndLadders",
    image: "/thumbnails/SnakesAndLadders_thumb.png",
    description: "Classic race-to-the-finish board game. Climb ladders, avoid snakes, and be the first to the top!"
  },
  {
    name: "Wheel of Destiny",
    path: "/Games/WheelOfDestiny",
    image: "/thumbnails/WheelOfDestiny_thumb.png",
    description: "Spin the wheel to get a random result from a customizable set of options. Perfect for games, challenges, or just adding some fun randomness to your day!"
  },
  {
    name: "Wordsearch",
    path: "/Games/WordSearch",
    image: "/thumbnails/WordSearch_thumb.png",
    description: "Find hidden words in a grid of letters. Play solo or with friends!"
  },
  {
    name: "Closest Guess",
    path: "/Games/ClosestGuess",
    image: "/thumbnails/ClosestGuess_thumb.png",
    description: "Guess numeric answers and score points based on how close you are to the target."
  },
  // {
  //   name: "Spot The Ball",
  //   path: "/Games/SpotTheBall",
  //   image: "/thumbnails/SpotTheBall_thumb.png",
  //   description: "Place a marker where you think the missing football is. Closest guess wins the round."
  // },
  {
    name: "Territory",
    path: "/Games/Territory",
    image: "/thumbnails/Territory_thumb.png",
    description: "Logic puzzle where you place one marker per row, column, and territory without touching."
  },
  {
    name: "Impulse Trader",
    path: "/Games/ImpulseTrader",
    image: "/thumbnails/ImpulseTrader_thumb.png",
    description: "Rush through rapidly changing prices and turn quick taps into profit."
  }
];

games.push({
  name: "Solitaire",
  path: "/Games/Solitaire",
  image: "/thumbnails/Solitaire_thumb.png",
  description: "Classic single-player card game. Move all cards to the foundations by suit and rank."
});

export function GamesBreadcrumb({ game }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
        <Link
          to="/"
          className="font-medium transition-colors hover:text-slate-900 dark:hover:text-slate-100"
          onClick={() => { window.scrollTo({ top: 0, behavior: 'auto' }); }}
        >
          Lobby
        </Link>
        {game !== "Featured Games" && (
            <>
        <span aria-hidden="true">/</span>
        <Link
          to="/Games"
          className="font-medium transition-colors hover:text-slate-900 dark:hover:text-slate-100"
          onClick={() => { window.scrollTo({ top: 0, behavior: 'auto' }); }}
        >
          Featured Games
        </Link>
        </>
        )}  
        {game && (
          <>
            <span aria-hidden="true">/</span>
            <span className="font-medium text-slate-700 dark:text-slate-200">{game}</span>
          </>
        )}
      </div>
    </nav>
  );
}

export function PlayGameLink({ game, gameTitle }) {
  return (
    <div className="mt-8 flex justify-center">
      <Link
        to="/"
        state={{ openCreateRoom: true, createGameType: game }}
        className="inline-block px-6 py-2 rounded-lg bg-emerald-600 text-white font-semibold shadow hover:bg-emerald-700 transition text-lg"
        onClick={() => { window.scrollTo({ top: 0, behavior: 'auto' }); }}
      >
        Start Playing {gameTitle || game}
      </Link>
    </div>
  );
}

export default function GamesIndex() {
  // Sort games alphabetically by name
  const sortedGames = [...games].sort((a, b) => a.name.localeCompare(b.name));
  return (
    <div className="mx-auto p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Featured Games" />
      <h1 className="text-3xl font-bold mb-6 text-slate-900 dark:text-slate-100">Featured Games</h1>
      <div className="mt-6 mb-6 text-gray-700 dark:text-gray-300">We have curated a selection of our most popular and exciting games for you to enjoy with friends!
         Click on any game below to learn more about it and start playing for free online.</div>

      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2">
        {sortedGames.map((game) => (
          <Link
            key={game.name}
            to={game.path}
            className="block rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/60 shadow hover:shadow-lg transition p-4 group"
            onClick={() => { window.scrollTo({ top: 0, behavior: 'auto' }); }}
          >
            <div className="flex flex-row items-start gap-4">
              <img
                src={game.image}
                alt={game.name}
                className="w-20 h-20 object-contain rounded group-hover:scale-105 transition bg-white dark:bg-slate-900/60 flex-shrink-0"
              />
              <div className="flex flex-col justify-center">
                <div className="text-xl font-semibold mb-1 group-hover:text-emerald-700 dark:group-hover:text-emerald-300 transition text-slate-900 dark:text-slate-100">
                  {game.name}
                </div>
                <div className="text-sm text-gray-600 dark:text-gray-300">{game.description}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
